// Meta+Ctrl+Alt+Shift+Key
export function getShortcut(event: KeyboardEvent) {
  const { metaKey, ctrlKey, altKey, shiftKey, key } = event
  const names = [metaKey ? 'Meta' : '', ctrlKey ? 'Ctrl' : '', altKey ? 'Alt' : '', shiftKey ? 'Shift' : '', key]
  return names.filter(name => !!name).join('+')
}
